import { inject, Injectable, Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Store } from '@ngrx/store';
import { Dictionary } from '@ngrx/entity';
import { ICoordinateSystem } from '@app/api/interfaces/coordinate-system.interface';
import { ICustomCoordinates } from '@app/api/interfaces/common/custom-coordinates';
import { selectCoordinateSystemEntities } from '@app/core/coordinate-systems/store/coordinate-systems/coordinate-systems.selectors';

@Injectable({
  providedIn: 'root',
})
export class CoordinateSystemsLookupService {
  private readonly store = inject(Store);

  public readonly entities: Signal<Dictionary<ICoordinateSystem>> = toSignal(
    this.store.select(selectCoordinateSystemEntities),
    { initialValue: {} }
  );

  public getById(coordinateSystemId: string | null | undefined): ICoordinateSystem | null {
    return (coordinateSystemId && this.entities()[coordinateSystemId]) || null;
  }

  public getFor(customCoordinates: ICustomCoordinates | null | undefined): ICoordinateSystem | null {
    return this.getById(customCoordinates?.coordinateSystemId);
  }
}
